import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import styles from './ModalUpdatePageMessage.module.scss';
import { useModalUpdatePageMessage } from './useModalUpdatePageMessage';
import { WEBSITE_TITLE } from '@/src/utils/constants';

export const ModalUpdatePageMessage = () => {
    //--------------------------------------
    const { isOutdated, latestVersion, isOpen, handleClose } = useModalUpdatePageMessage();
    //--------------------------------------
    if (!isOpen) return null;

    return (
        <div className={styles.modal}>
            <div className={`${styles.main}`}>
                <div className={styles.popUp}>
                    <header className={styles.headerModal}>
                        <h2 className={styles.titleModal}>{WEBSITE_TITLE}</h2>
                        <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                            <use href={CLOSE}></use>
                        </svg>
                    </header>

                    <div className={styles.textContainer}>
                        <h2 className={styles.title}>Update Available</h2>
                        <p className={styles.text}>
                            <strong>A new version of the website ({latestVersion}) is available!</strong>
                            <br />
                            Please refresh the page in your browser to load the new version.
                        </p>

                        <details className={styles.details}>
                            <summary>How to force reload in your browser?</summary>
                            <ul>
                                <li>
                                    <strong>Google Chrome:</strong> Press <code>Ctrl + Shift + R</code> (Windows/Linux) or <code>Cmd + Shift + R</code> (Mac).
                                </li>
                                <li>
                                    <strong>Mozilla Firefox:</strong> Press <code>Ctrl + Shift + R</code> (Windows/Linux) or <code>Cmd + Shift + R</code> (Mac).
                                </li>
                                <li>
                                    <strong>Safari:</strong> Press <code>Cmd + Option + R</code> to force reload.
                                </li>
                                <li>
                                    <strong>Microsoft Edge:</strong> Press <code>Ctrl + Shift + R</code>.
                                </li>
                                <li>
                                    <strong>Mobile (Chrome/Safari):</strong> Close the tab and reopen it.
                                </li>
                            </ul>
                        </details>
                    </div>
                </div>
            </div>
        </div>
    );
};
